import { motion } from "framer-motion"; // Importing framer-motion for animations
import CountUp from "react-countup"; // Importing CountUp for counting numbers
import { useNavigate } from "react-router-dom";
import { Typewriter } from "react-simple-typewriter"; // Importing Typewriter for text animation
import "./Hero.css"; // Importing CSS for styling
import HeroSwiper from "./hero_folder/HeroSwiper";

import Profile1 from "./homepage_images/profile1.jpg";
import Profile2 from "./homepage_images/profile2.jpg";
import Profile3 from "./homepage_images/profile3.jpg";

import Logo from "../logo/universe.png"; // Importing logo image
// importing icons from material user interface

import IsoIcon from "@mui/icons-material/Iso";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const Hero = () => {
  const redirect = useNavigate();
  return (
    <div className="heroWrap mobileRWDhide">
      <section className="hero-section fx-cl fx-jc fx-ac space2">
        <div className="fx-jc">
          <motion.div
            className="heroGenCont fx-cl fx-ac space2"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <div className="heroTop fx-cl fx-ac space2">
              <motion.p
                className="subheading"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
              >
                <strong>Universe!</strong> Inventory Management.
              </motion.p>

              <h1 className="main-heading">
                <Typewriter
                  words={[
                    "The Universe! Inventory Management Platform",
                    "Manage Your Inventory & Sales Effortlessly",
                    "Where Everybody is Seen, Heard, and Valued",
                    "Building Future Businesses from the Ground Up",
                    "Meet Your Next Generation Inventory System",
                    "Strong Foundation, The Endless Possibilities",
                    "Empowering Businesses for a Brighter Tomorrow",
                  ]}
                  loop={Infinity}
                  cursor
                  cursorStyle="|"
                  typeSpeed={30}
                  deleteSpeed={10}
                  delaySpeed={5000}
                />
              </h1>

              <motion.p
                className="description"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.7 }}
              >
                {" "}
                We’re a leading business management platform, empowering
                businesses to grow through reliable software, integrity, and a
                safe, supportive environment.
                {/* Universe is the all-in-one POS and inventory system designed to help your
          business track stock, streamline sales, and grow faster.” */}
              </motion.p>
            </div>
            <motion.div
              className="fx-cl fx-ac space2"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.9 }}
            >
              <div className="fx-ac space3">
                <button
                  className="shop-btn fx-ac spacem"
                  onClick={() => redirect("/create_new_account")}
                >
                  <span>Get started in few steps</span>
                  <div className="getStrtIcon fx-ac fx-jc">
                    <ArrowForwardIcon />
                  </div>
                </button>
                {/* <button className="shop-btn fx-ac spacem">
                  <CloudUploadIcon fontSize="large" />
                  <span>See how it works</span>
                </button> */}
                <figure className="heroFigure fx-ac spacem">
                  <div className="fx-ac">
                    <img src={Profile2} alt="" />
                    <img src={Profile3} alt="" />
                    <img src={Profile1} alt="" />
                  </div>
                  <div style={{ width: "21rem" }}>
                    <p>Connecting and serving users around the world</p>
                  </div>
                </figure>
              </div>
            </motion.div>
            <div className="heroImage">
              <HeroSwiper />
            </div>
            {/* <figure className="heroBaseBar fx-ac spacem">&nbsp;</figure> */}
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Hero;
